import React, {Fragment} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

import { withStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#ffffff",
    },
    secondary: blue,
  },
  status: {
    danger: 'pink',
  },
});

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.gray,
      },
    },
  },
}))(MenuItem);

const Navbar = ({logo, menuItems, navbarColor, navbarTextColor}) => {

  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    title: {
      flexGrow: 1,
    },
    navbarColor: {
      backgroundColor: navbarColor,
    },
    navbarTextColor: {
      color: navbarTextColor,
    }
  }));

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const redirectTo = (url) => {
    window.location.href = url;
  };

  return (
    <MuiThemeProvider theme={theme}>
      <div className={classes.root}>
        <AppBar position="static" className={classes.navbarColor}>
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              { logo!=='' ?
                 <a href={process.env.REACT_APP_PREFIX_DIR}>
                   <img
                     src={logo}
                     className="img-logo"
                     alt="MAX Delivery"
                     />
                 </a>
                :
                null
              }

            </Typography>

            {
              menuItems.length>0 ?
                <Fragment>
                  <IconButton className="mobile-menu" color="inherit" aria-label="menu" onClick={handleClick}>
                     <MenuIcon />
                  </IconButton>

                  <StyledMenu
                    id="customized-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                  >
                  {
                    menuItems.map((item, index)=>(
                      <StyledMenuItem key={index} onClick={()=>redirectTo(item.description)}>
                        <ListItemText primary={item.title} />
                      </StyledMenuItem>
                    ))
                  }
                  </StyledMenu>

                  {
                    menuItems.map((item, index)=>(
                      <Button
                        key={index}
                        color="inherit"
                        className={"desktop-menu " + classes.navbarTextColor}
                        onClick={()=>redirectTo(item.description)}
                        >
                        {item.title}
                      </Button>
                    ))
                  }
                </Fragment>
              :
              null
            }




          </Toolbar>
        </AppBar>
      </div>
    </MuiThemeProvider>
  )
}

export default Navbar;
